// Live View Section - Contains Vehicle Info, Focus Track, Share Location, KML Download, Today Timeline, Right-click Add as POI, Status Based Search, Area Based Search, Poi List
import { useRef } from "react";
import { Box, Button, Modal, Snackbar } from "@mui/material";
import ReactAudioPlayer from "react-audio-player";
import CancelIcon from "@mui/icons-material/Cancel";
import ListIcon from "@mui/icons-material/List";
import { SidebarComponent } from "@syncfusion/ej2-react-navigations";
import "leaflet-contextmenu";
import "leaflet-contextmenu/dist/leaflet.contextmenu.css";
import _ from "lodash";
import moment from "moment";
import React, { useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { LayersControl, MapContainer, Marker, Polyline, Circle, Popup, WMSTileLayer, useMap } from "react-leaflet";
import { FullscreenControl } from "react-leaflet-fullscreen";
import MarkerClusterGroup from "@changey/react-leaflet-markercluster";
import { connect, useDispatch } from "react-redux";
import ITCImg from "../../../assets/infofleet/infofleet_logo_transparent.png";
import notificationsound from "../../../assets/infofleet/notification.mp3";
import * as liveViewAction from "../../../infofleet/ducks/liveView";
import { toAbsoluteUrl } from "../../../infofleet/utils/utils";
import { MapLayer, mapurl, serverurl } from "../../router/config";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { OverspeedIcon, IdleIcon } from "../../component/MapComponents/MapIcons";
import SelectDriverDropdown from "../../component/controls/SelectDriverDropdown";
import TopBarFilter from "../../component/Liveview/Topbarfilter";
import SearchPOI from "../../component/controls/SearchPOI";
import SearchbyAreaname from "../../component/controls/SearchbyAreaname";
import CustomRotatedMarker from "../../component/MapComponents/CustomRotatedMarker";
import FocusAssetMarker from "../../component/MapComponents/FocusAssetMarker";
import POIFilter from "../../component/MapComponents/POIFilterMarker";
import CustomSideBarComponent from "../../component/Liveview/SidebarComponent";
import ListViewGridTable from "../../component/Liveview/ListViewGridTable";
import AddGeofencebody from "../../component/Liveview/AddGeofence";
import SingleAssetInfo from "../../component/Liveview/SingleAssetInfo";
import AddrightclickPOI from "../../component/Liveview/AddPOI";
import api from "../../router/axiosConfig";
import ZoomLockController from "./ZoomLockController";
import { Tooltip as MuiTooltip, Alert as MuiAlert, } from '@mui/material';

const GOOGLEAPIKEY = process.env.REACT_APP_GOOGLE_API_KEY;
const ZoomHandler = ({ lat, lng, zoom }) => {
  const map = useMap();
  useEffect(() => {
    if (lat && lng) {
      map.setView([lat, lng], zoom || 14);
    }
  }, [lat, lng, zoom, map]);
  return null;
};

const MapRefSetter = ({ mapRef, mapInstanceRef }) => {
  const map = useMap();
  useEffect(() => {
    if (map) {
      mapRef.current = map;
      mapInstanceRef.current = map;
    }
  }, [map, mapRef, mapInstanceRef]);
  return null;
};

const LiveViewMap = ({ liveView, maplayer }) => {
  const fallbackPosition = [25.276987, 55.296249]; // Example: Dubai center
  const mapRef = useRef(null);
  useEffect(() => {
    localStorage.removeItem("allEntries");
    localStorage.removeItem("previoustrack");
    localStorage.removeItem("showtrack");
    localStorage.removeItem("trackvehicleid");
    localStorage.removeItem("selectedvehicleid");
    dispatch(liveViewAction.actions.selectedVId(""));
    getWindowDimension();
    api.get(serverurl + "getLoggedUserAutoRefreshTime").then(function (response) {
      const refreshdata = response.data;
      if (refreshdata && refreshdata?.time && refreshdata.time > 0 && refreshdata?.active && refreshdata?.active === true) {
        const LiveViewStatusID = setInterval(() => {
          trackdatafunction();
          getrefreshliveviewdata();
          updatedselectedvehicle();
        },
          refreshdata.time && refreshdata.time > 0 ? (refreshdata.time / 60) * 60 * 1000 : 10 * 60 * 1000
        );
        localStorage.setItem("LiveView_interval", LiveViewStatusID);
      }
    });
    api.get(serverurl + "getTreeViewList", {
      params: {
        vehicleIds: -1,
      },
    }).then(function (response) {
      var fullassetarray =
        response && response?.data ? response?.data?.items.filter(function (obj) {
          return obj.type === "child";
        }) : "";

      var fullvehicleid = fullassetarray && fullassetarray.length !== 0 ?
        fullassetarray?.map((item, index) => {
          return item?.vehicleId;
        }) : "";
      getallliveviewvehicle(fullvehicleid);
    });
  }, []);


  //start - to reset the map position when mapview changed to informap from google to avoid outof focus
  // function handleOnSetView() {  
  // }
  useEffect(() => {
    if (!mapRef.current) return;
    const zoomType = maplayer.MapZoomView;
    if (zoomType === "default") {
      mapRef.current.setZoom(liveView?.states?.zoom || 12);
    } else if (zoomType === "highway") {
      mapRef.current.setZoom(12);
    } else if (zoomType === "street") {
      mapRef.current.setZoom(15);
    } else if (zoomType === "building") {
      mapRef.current.setZoom(16);
    }
    if (maplayer.MapLayer == "informap") {
      // console.log("maplayer.MapLayer : ", maplayer.MapLayer)
      //  handleOnSetView()
    }
  }, [maplayer.MapLayer, maplayer.MapZoomView])
  //end - to reset the map position when mapview changed to informap from google to avoid outof focus

  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: "",
    severity: "success",
  });
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };
  const [filterpoidetails, FilterPOIDetails] = React.useState("");
  const [listviewdrawer, setListViewDrawer] = React.useState(false);
  const mapslayer = maplayer.MapLayer;
  const cluster = maplayer.ClusterView;
  const mapzoomview = _.toString(maplayer.MapZoomView);
  const { BaseLayer } = LayersControl;
  const [height, setHeight] = React.useState(window.innerHeight);
  const windowheight = height - 50;
  const [loaderview, LoaderView] = React.useState("");
  const mapview = {
    height: windowheight + "px",
    width: "100%",
    overflow: "hidden",
  };
  var sidebarObj1 = "Sidebar"
  const storedata = _.filter(liveView.data, function (val) {
    return val !== null;
  });
  const dispatch = useDispatch();
  const singleassetdata = liveView.selectedVId;
  const singleassetview = liveView.singleassetview;
  var alertdata = liveView.selectednotification;
  const [states, setState] = React.useState({
    viewlimit: "",
    expiryduration: "",
    mode: "",
    phoneno: "",
    name:
      singleassetdata.driverName +
      singleassetdata.id +
      singleassetdata.location,
    vehicleIds: "",
    zoom:
      alertdata ? 16 : 10,
    sendMode: "1",
    lat: 25.190662,
    lng: 55.270411,
    selectedassetid: "",
    filter: false,
    locationfilter: false,
    poiIds: "",
    poifilter: false,
    focustrack: "",
    statetrackdata: "",
    previoustrackdata: "",
    alertscroll: false,
    deviceuniqhueid: "",
  });
  const [areatargetsearch, setAreatargetsearch] = React.useState("");
  const [areazoomlevel, setAreazoomlevel] = React.useState("");
  const [poistate, setPoistate] = React.useState({
    poigroup: "",
    poicategory: "",
    poilat: "",
    poilng: "",
  });

  const [geofencestatelatlng, setGeofencestatelatlng] = React.useState({
    geofencelat: "",
    geofencelng: "",
    radius: 400,

  })
  const [geofencecircleenable, setGeofenceCircleEnable] = React.useState(false);
  const [Geofencetoggleicon, SetGeofenceToggleicon] = React.useState(1);
  const [FocusAsset, setFocusAsset] = React.useState(false);
  const [sensorview, setSensorView] = React.useState(false);
  const [AddPOI, setAddPOI] = React.useState(false);
  const [actions, Actions] = React.useState();
  const [levels, Levels] = React.useState();
  const [vehiclelist, VehicleList] = React.useState();
  const [areanameposition, setAreanameposition] = React.useState({
    areapositionlat: "",
    areapositionlng: "",
  });
  const [fullscreenmode, setFullScreenMode] = React.useState(0);
  const [livepanelfilter, setLivepanelfilter] = React.useState({
    Moving: false,
    Parked: false,
    NoSignal: false,
    Stopped: false,
    Engineon: false,
    searchbyDriver: false,
    serachbyareaname: false,
  });
  const [InputEventStatus, setInputEventStatus] = React.useState("");
  var panelfiltered_storedata;
  const getWindowDimension = () => {
    window.addEventListener("resize", updateWidthAndHeight);
    return () => window.removeEventListener("resize", updateWidthAndHeight);
  };
  const updateWidthAndHeight = () => {
    setHeight(window.innerHeight);
  };

  if (livepanelfilter.searchbyDriver) {
    var driverfilterdata = [];
    for (var i = 0; i < states.vehicleIds.length; i++) {
      const driverfilter = storedata.filter(item => item.vehicleId === states.vehicleIds[i])
      if (driverfilter.length > 0) {
        driverfilterdata.push(driverfilter[0])
      }
    }
    panelfiltered_storedata = _.filter(driverfilterdata, function (val) {
      return val !== null;
    });

  }

  if (livepanelfilter.serachbyareaname) {
    panelfiltered_storedata = _.filter(liveView.filterData, function (val) {
      return val !== null;
    });

  }
  else if (livepanelfilter.Moving) {
    panelfiltered_storedata = _.filter(liveView.MovingFilterData, function (val) {
      return val !== null;
    });
  } else if (livepanelfilter.Parked) {
    panelfiltered_storedata = _.filter(liveView.ParkedFilterData, function (val) {
      return val !== null;
    });
  } else if (livepanelfilter.NoSignal) {
    panelfiltered_storedata = _.filter(liveView.NosignalFilterData, function (val) {
      return val !== null;
    });
  } else if (livepanelfilter.Stopped) {
    panelfiltered_storedata = _.filter(liveView.StoppedFilterData, function (val) {
      return val !== null;
    });
  } else if (livepanelfilter.Engineon) {
    panelfiltered_storedata = _.filter(liveView.EngineOnFilterData, function (val) {
      return val !== null;
    });
  }

  // Vehicle Count for Top Fixed Bar
  const filteredData = states.filter === true ? panelfiltered_storedata : storedata;
  var vehicletypeBike = filteredData ? _.filter(filteredData, function (rec) {
    return rec.vehicleType === "Bike";
  }) : "";
  var vehicletypeOthers = filteredData !== "" && filteredData !== undefined && filteredData !== null
    ? _.filter(filteredData, function (rec) {
      return rec.vehicleType !== "Bike";
    }) : "";

  var nosignalCount = filteredData !== "" && filteredData !== undefined && filteredData !== null
    ? _.countBy(filteredData, function (rec) {
      return rec.vmode === "No Signal";
    }) : "";
  const noScount = nosignalCount.true;
  var movingCount = filteredData ? _.countBy(filteredData, function (rec) {
    return rec.vmode === "Moving";
  }) : "";
  const movecount = movingCount.true;
  var parkingCount = filteredData ? _.countBy(filteredData, function (rec) {
    return rec.vmode === "Parked";
  }) : "";
  const parkcount = parkingCount.true;
  var stoppedCount = filteredData ? _.countBy(filteredData, function (rec) {
    return rec.vmode === "Stopped";
  }) : "";
  const Stoppedcount = stoppedCount.true;

  var engineonCount = filteredData !== "" && filteredData !== undefined
    ? _.countBy(filteredData, function (rec) {
      return rec.vmode === "Idling Engine ON";
    })
    : "";
  const Engineoncount = engineonCount.true;
  const filterCount = {
    noScount: noScount,
    movecount: movecount,
    parkcount: parkcount,
    Stoppedcount: Stoppedcount,
    Engineoncount: Engineoncount
  }
  function closeSingleselection() {
    setFocusAsset(false);
  }
  // Vehicle Count for Top Fixed Bar

  // start-Function to get all the Live View vehicle Ids and Passed to get the Live View Status Datas
  const getrefreshliveviewdata = async () => {
    api.get(serverurl + "getTreeViewList", {
      params: {
        vehicleIds: -1,
      },
    }).then(function (response) {
      var fullassetarray = response && response?.data ? response.data.items.filter(function (obj) {
        return obj.type === "child";
      }) : "";

      var fullvehicleid = fullassetarray && fullassetarray.length !== 0
        ? fullassetarray.map((item, index) => {
          return item.vehicleId;
        }) : "";
      getallliveviewvehicle(fullvehicleid);
    });
  };
  // end-Function to get all the Live View vehicle Ids and Passed to get the Live View Status Datas

  // start-Function to get all the Live View Status
  const getallliveviewvehicle = async (event) => {
    LoaderView("true");
    const SERVICE_URL = serverurl + "getLiveStatusData";
    const requestBody = {
      vehicleIds: states.vehicleIds ? _.toString(states.vehicleIds) : _.toString(event),
    };
    const config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
      withCredentials: true,
    };
    const response = await api.post(SERVICE_URL, requestBody, config);
    LoaderView("false");
    if (response.data && (response.data).length > 0) {
      dispatch(liveViewAction.actions.getLiveView(response.data[0].items));
    }
    const storedata = (response.data && (response.data).length > 0) ? response.data[0].items : "";
    var moving_data = storedata ? storedata.filter(function (obj) {
      return obj.vmode === "Moving";
    }) : "";
    dispatch(liveViewAction.actions.MovingFilterData(_.orderBy(moving_data, ["speed"], ["desc"])));
    var parking_data = storedata ? storedata.filter(function (obj) {
      return obj.vmode === "Parked";
    }) : "";

    dispatch(liveViewAction.actions.ParkedFilterData(_.orderBy(parking_data, ["statusDurationMins"], ["desc"])));

    var nosignal_data = storedata ? storedata.filter(function (obj) {
      return obj.vmode === "No Signal";
    }) : "";

    dispatch(liveViewAction.actions.NosignalFilterData(_.orderBy(nosignal_data, ["statusDurationMins"], ["desc"])));
    var stopped_data = storedata ? storedata.filter(function (obj) {
      return obj.vmode === "Stopped";
    }) : "";

    dispatch(liveViewAction.actions.StoppedFilterData(_.orderBy(stopped_data, ["statusDurationMins"], ["desc"])));

    var engineonidle_data = storedata ? storedata.filter(function (obj) {
      return obj.vmode === "Idling Engine ON";
    }) : "";
    dispatch(liveViewAction.actions.EngineOnFilterData(_.orderBy(engineonidle_data, ["statusDurationMins"], ["desc"])));
  };

  const sidebarselectedAsset = (e) => {
    api.get(serverurl + "getCurrentStatusDetails", {
      params: {
        vehicleId: e.vehicleId,
      },
    }).then(function (response) {
      dispatch(liveViewAction.actions.selectedVId(response.data));
    });
    dispatch(liveViewAction.actions.singleassetview("hide"));
    setState({
      ...states,
      zoom: 16,
      lat: _.toNumber(e.latitude),
      lng: _.toNumber(e.longitude),
      selectedassetid: _.toNumber(e.vehicleId),
    });
    setFocusAsset(true);
    localStorage.setItem("selectedvehicleid", e.vehicleId);
  };
  //end- Function to Pass the Sidebar selected Vehicle details to Redux Store


  function selectedAsset(e) {
    localStorage.removeItem("allEntries");
    localStorage.removeItem("previoustrack");
    localStorage.removeItem("showtrack");
    localStorage.removeItem("trackvehicleid");
    api.get(serverurl + "getCurrentStatusDetails", {
      params: {
        vehicleId: e.vehicleId,
      },
    }).then(function (response) {
      dispatch(liveViewAction.actions.selectedVId(response.data));
    });

    api.get(serverurl + "getInputEventStatus", {
      params: {
        vehicleId: e.vehicleId,
      },
    }).then(function (response) {
      setInputEventStatus(response.data);
    });

    dispatch(liveViewAction.actions.singleassetview("show"));
    localStorage.setItem("selectedvehicleid", e.vehicleId);
    setState({
      ...states,
      zoom: 16,
      lat: _.toNumber(e.latitude),
      lng: _.toNumber(e.longitude),
      selectedassetid: _.toNumber(e.vehicleId),
      focustrack: false,
      deviceuniqhueid: _.toString(e.uniqueId),
    });
    setFocusAsset(true);
  }
  function updatedselectedvehicle() {
    var selectedvehicle = localStorage.getItem("selectedvehicleid");
    if (selectedvehicle) {
      api.get(serverurl + "getCurrentStatusDetails", {
        params: {
          vehicleId: selectedvehicle,
        },
      }).then(function (response) {
        dispatch(liveViewAction.actions.selectedVId(response.data));
      });
    }
  }
  function closesingleasset() {
    setState({ ...states, focustrack: false });
    setFocusAsset(false);
    dispatch(liveViewAction.actions.singleassetview("hide"));
    localStorage.removeItem("allEntries");
    localStorage.removeItem("previoustrack");
    localStorage.removeItem("showtrack");
    localStorage.removeItem("trackvehicleid");
    localStorage.removeItem("selectedvehicleid");
  }

  // Right Sidebar Option
  const righttoggleClick = () => {
    sidebarObj1.toggle();
  };
  const onCreateGeofence = () => {
    sidebarObj1.element.style.visibility = "visible";
  };

  const opensidebar = () => {
    SetGeofenceToggleicon(2);
  };
  const closesidebar = () => {
    SetGeofenceToggleicon(1);
  };

  function poiidselect(event) {
    setState({ ...states, poiIds: event.value });
    LoaderView("true");
    setState({
      ...states,
      poifilter: true,
    });
    api.get(serverurl + "GetPoisByPoiIds", {
      params: {
        poiIds: _.toString(event.value),
      },
    }).then(function (response) {
      LoaderView("false");
      FilterPOIDetails(response.data);
    });
  }
  const livepanelclick = (event) => {
    LoaderView("true");
    setFocusAsset(false); // set it as false whenever filter option changes 
    setState({
      ...states,
      filter:
        (event.target.name === "Moving" ||
          event.target.name === "Parked" ||
          event.target.name === "No Signal" ||
          event.target.name === "Stopped" ||
          event.target.name === "Engine ON") &&
          event.target.checked === true
          ? true
          : false,
      zoom: 9,
    });
    setLivepanelfilter({
      ...livepanelfilter,
      Moving: event.target.name === "Moving" ? event.target.checked : false,
      Parked: event.target.name === "Parked" ? event.target.checked : false,
      NoSignal: event.target.name === "No Signal" ? event.target.checked : false,
      Stopped: event.target.name === "Stopped" ? event.target.checked : false,
      Engineon: event.target.name === "Engine ON" ? event.target.checked : false,
      searchbyDriver: false,
      serachbyareaname: false
    });
  };

  function locationChange(event) {
    setState({
      ...states,
      zoom: areazoomlevel,
      filter: true,
      locationfilter: true,
    });
    setAreatargetsearch(event.target.value);
  }
  const location_submit = (event) => {
    LoaderView("true");
    setState({
      ...states,
      zoom: areazoomlevel,
      filter: true,
      locationfilter: true,
    });

    api.get(serverurl + "getSearchStatusGridData", {
      params: {
        target_param: "Location",
        target_search: areatargetsearch,
      },
    }).then(function (response) {
      LoaderView("false");
      dispatch(liveViewAction.actions.filterData(response.data));
    });
    setLivepanelfilter({
      ...livepanelfilter,
      Moving: false,
      Parked: false,
      NoSignal: false,
      Stopped: false,
      Engineon: false,
      searchbyDriver: false,
      serachbyareaname: true,
    });

  };

  const poi_submit = (event) => {
    LoaderView("true");
    setState({
      ...states,
      poifilter: true,
    });
    api.get(serverurl + "GetPoisByPoiIds", {
      params: {
        poiIds: _.toString(states.poiIds),
      },
    }).then(function (response) {
      LoaderView("false");
      FilterPOIDetails(response.data);
    });
  };

  const location_close = (event) => {
    setState({
      ...states,
      zoom: 9,
      filter: false,
      locationfilter: false,
    });
    setAreatargetsearch("");
    setAreazoomlevel("");
    setAreanameposition({
      areapositionlat: "",
      areapositionlng: "",
    });
  };
  const poi_close = (event) => {
    setState({
      ...states,
      poifilter: false,
    });
    FilterPOIDetails("");
  };
  // Top Bar Functions

  // start - Function for Focus Track Click
  function handleFocusTrackClick(focustrackChecked, existingTrackdata, PreviousTrackdata) {
    if (focustrackChecked === "true") {
      setState({
        ...states,
        focustrack: focustrackChecked,
        statetrackdata: existingTrackdata,
        previoustrackdata: PreviousTrackdata,
      });
    }
    else {
      setState({
        ...states,
        focustrack: false,
      });
    }
  }
  const mapInstanceRef = useRef(null);

  function trackdatafunction() {
    var trackstatus = localStorage.getItem("showtrack");
    var trackvehicleid = localStorage.getItem("trackvehicleid");
    if (trackstatus === "true" && trackvehicleid) {
      api.get(serverurl + "getCurrentStatusDetails", {
        params: {
          vehicleId: trackvehicleid,
        },
      }).then(function (response) {
        var existingEntries = JSON.parse(localStorage.getItem("allEntries"));
        var previoustrackEntries = JSON.parse(
          localStorage.getItem("previoustrack")
        );
        if (existingEntries == null) existingEntries = [];
        existingEntries.push(response.data);
        localStorage.setItem("allEntries", JSON.stringify(existingEntries));
        var existingTrackdata = JSON.parse(
          localStorage.getItem("allEntries")
        );
        setState({
          ...states,
          statetrackdata: existingTrackdata,
          previoustrackdata: previoustrackEntries,
          focustrack: trackstatus,
          //zoom: 16,
          lat: _.toNumber(response.data.latitude),
          lng: _.toNumber(response.data.longitude),
        });
      });
    }
  }

  var focusicon =
    FocusAsset === true && singleassetdata && storedata ? storedata.filter(function (obj) {
      return obj.vehicleId === singleassetdata.vehicleId;
    }) : "";
  const rightclickitems = [
    {
      text: "Add as POI",
      callback: (e) => addrightclickpoi(e),
    },
    {
      text: "Add as Geofence",
      callback: (e) => addrightclickgeofence(e),
    },
    {
      text: "View POI on Map ",
      callback: (e) => addRightClickViewPoi(e),
    },
  ];
  // function addrightclickpoi(e) {
  //   setPoistate({ ...poistate, poilat: e.latlng.lat, poilng: e.latlng.lng });
  //   setAddPOI(true);
  // }

  const [lastSelectedPOI, setLastSelectedPOI] = React.useState(null);
  const [poiLock, setPoiLock] = React.useState(false);

  function addrightclickpoi(e) {
    const lat = e.latlng.lat;
    const lng = e.latlng.lng;
    setPoistate({ ...poistate, poilat: lat, poilng: lng });
    setAddPOI(true);
    const map = mapInstanceRef.current;
    const currentZoom = map?.getZoom() ?? 14; // ✅ NOW WORKS
    setPoiLock(true);
    setLastSelectedPOI({
      lat,
      lng,
      zoom: Math.min(currentZoom + 2, 17),
    });
  }


  // Modal Popup Close
  const handleClose = () => {
    setAddPOI(false);
  };
  // Start- geofence section
  function addrightclickgeofence(e) {
    const action_url = "GetGeofenceActions";
    api.get(serverurl + action_url).then(function (response) {
      Actions(response.data);
    });
    const levels_url = "GetGeofenceLevels";
    api.get(serverurl + levels_url).then(function (response) {
      Levels(response.data);
    });
    const url = "GetGeofenceSupportedVehicleTreeView";
    api.get(serverurl + url, {
      params: {
        geofenceTypeId: 1,
        geofenceId: -1,
      },
    }).then(function (response) {
      VehicleList(response.data.items);
    });

    SetGeofenceToggleicon(1)
    setGeofencestatelatlng({ ...geofencestatelatlng, geofencelat: e.latlng.lat, geofencelng: e.latlng.lng });
    setGeofenceCircleEnable(true);
  }

  function addRightClickViewPoi(e) {
    const map = mapInstanceRef.current;
    if (map) {
      const bounds = map.getBounds();
      const left = bounds.getWest();
      const bottom = bounds.getSouth();
      const right = bounds.getEast();
      const top = bounds.getNorth();
      const bbox = `${left},${bottom},${right},${top}`;
      console.log(bbox);
      LoaderView("true");
      setState({
        ...states,
        poifilter: true,
      });

      api.get(serverurl + "GetPoisByBoundingBox", {
        params: {
          bbox: bbox,
        },
      }).then(function (response) {
        LoaderView("false");
        FilterPOIDetails(response.data);
      }).catch(function (error) {
        LoaderView("false");
        console.error("Error fetching POIs by bbox:", error);
      });
    }
  }


  const handleReInitializeGeofence = () => {
    SetGeofenceToggleicon(2)
    sidebarObj1.toggle()
    setGeofenceCircleEnable(false)
    setGeofencestatelatlng({
      ...geofencestatelatlng,
      radius: 400,
      geofencelat: "",
      geofencelng: ""
    })
  };
  const geofenceRadius = (event) => {
    setGeofencestatelatlng({ ...geofencestatelatlng, radius: Math.round(event.target.value) });
  }
  const handleLoaderView = (value) => {
    LoaderView(value)
  }
  function userselect(e) {
    var zoomlevel = e.itemData.add2 === "static_city" ? 13 : 14;
    setAreazoomlevel(zoomlevel);
    setAreatargetsearch(e.itemData.add5);
    setAreanameposition({
      areapositionlat: e.itemData.area_cy,
      areapositionlng: e.itemData.area_cx,
    });
  }
  document.addEventListener("fullscreenchange", (event) => {
    if (document.fullscreenElement) {
      var FS = 1;
    } else {
      var FS = 0;
    }
    setFullScreenMode(FS);
  });

  var speed_violation_count = storedata ? _.filter(storedata, function (data) {
    return data.speedViolationOn === 1;
  }) : "";
  var idle_violation_count = storedata ? _.filter(storedata, function (data) {
    return data.idleViolationOn === 1;
  }) : "";

  // List View Section
  const listViewDrawer = (open) => (event) => {
    setListViewDrawer(open);
  };
  // List View Section

  var currentdate = new Date();
  const position = alertdata ? [alertdata.latitude, alertdata.longitude]
    : states.locationfilter === true && areanameposition ? [areanameposition.areapositionlat, areanameposition.areapositionlng]
      : focusicon && focusicon?.length > 0 ? [focusicon[0].latitude, focusicon[0].longitude]
        : [states.lat, states.lng];

  const handleAssetChange = (filter, vehicleIds) => {
    setState({
      ...states,
      filter: filter,
      vehicleIds: vehicleIds,
    });
    setLivepanelfilter({
      ...livepanelfilter,
      Moving: false,
      Parked: false,
      NoSignal: false,
      Stopped: false,
      Engineon: false,
      searchbyDriver: true,
      serachbyareaname: false,
    });

  }
  return (
    <>

      {loaderview === "true" ? "" : ""}


      <div className="LivePanelSidebar" id="Liveview">
        <div className="col-xl-12 p_0">
          {/* Top Fixed Header Section */}
          <>
            <div className="top_fixed_section">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="row">
                  <div className="col-sm-2 col-md-2 col-lg-2 pr_0">
                    <div className="row">
                      <SelectDriverDropdown handleAssetChange={handleAssetChange} />
                    </div>
                  </div>
                  <div className="col-sm-10 col-md-10 col-lg-10 icon_div_section p_0">
                    <div className="row">
                      <div className="col-sm-8 col-md-8 col-lg-6 liveviewicons">
                        <div className="row liveviewicons_row_div">
                          <TopBarFilter
                            livepanelfilter={livepanelfilter}
                            livepanelclick={livepanelclick}
                            filterCount={filterCount}
                            locationfilter={states.locationfilter}
                            fullscreen={fullscreenmode}
                            vehicletypeBike={vehicletypeBike}
                            vehicletypeOthers={vehicletypeOthers} />
                        </div>
                      </div>
                      <div className="col-sm-4 col-md-4 col-lg-3 flex_div flex_center auto_suggest_div">
                        <SearchbyAreaname
                          locationChange={locationChange}
                          location_submit={location_submit}
                          location_close={location_close}
                          locationfilter={states.locationfilter}
                          filter={states.filter}
                          userselect={userselect}
                          areatargetsearch={areatargetsearch} />
                      </div>
                      <div className="col-md-3 col-lg-3  flex_div flex_center hide_sm">
                        <SearchPOI
                          poiidselect={poiidselect}
                          poi_submit={poi_submit}
                          poifilter={states.poifilter}
                          poi_close={poi_close}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>

          <MapContainer
            center={position}
            zoom={states.focustrack === "true" ? 16 :
              mapzoomview === "default"
                ? states.zoom
                : mapzoomview === "building"
                  ? 16
                  : mapzoomview === "street"
                    ? 15
                    : mapzoomview === "highway"
                      ? 12
                      : 10}

            style={mapview}
            noWrap="true"
            projection="EPSG:4326"
            bbox="[-180.0, -90.0, 180.0, 90.0]"

            contextmenu={true}
            contextmenuWidth={130}
            contextmenuItems={rightclickitems}
          >
            <MapRefSetter mapRef={mapRef} mapInstanceRef={mapInstanceRef} />
            {!states.locationfilter && !poiLock &&
              <ZoomLockController zoomLevelName={maplayer.MapZoomView} position={position} />
            }
            {!poiLock && states.locationfilter && areanameposition && areanameposition.areapositionlat &&
              areanameposition.areapositionlng &&
              <ZoomHandler
                lat={areanameposition.areapositionlat}
                lng={areanameposition.areapositionlng}
                zoom={14}
              />
            }
            {!poiLock && states.lat && states.lng && states.zoom && singleassetdata &&
              <ZoomHandler
                key={singleassetdata?.vehicleId || "zoom-handler"}
                lat={states.lat} lng={states.lng} zoom={states.zoom}
              />
            }

            {mapslayer === "google" ? (
              <LayersControl position="topright">
                <BaseLayer checked name="Google Maps Roads">
                  <ReactLeafletGoogleLayer googleMapsLoaderConf={{ KEY: GOOGLEAPIKEY }} //KEY ####
                    type={'roadmap'}
                  />
                </BaseLayer>
                <BaseLayer name="Google Maps Satellite">
                  <ReactLeafletGoogleLayer googleMapsLoaderConf={{ KEY: GOOGLEAPIKEY }}
                    type={'satellite'}
                  />
                </BaseLayer>
                <BaseLayer name="Google Maps terrain">
                  <ReactLeafletGoogleLayer googleMapsLoaderConf={{ KEY: GOOGLEAPIKEY }}
                    type={'terrain'}
                  />
                </BaseLayer>
                <BaseLayer name="Google Maps hybrid">
                  <ReactLeafletGoogleLayer googleMapsLoaderConf={{ KEY: GOOGLEAPIKEY }}
                    type={'hybrid'}
                  />
                </BaseLayer>
                <BaseLayer name="Google Maps Traffic">
                  <ReactLeafletGoogleLayer googleMapsLoaderConf={{ KEY: GOOGLEAPIKEY }}
                    googleMapsAddLayers={[{ name: "TrafficLayer" }]}
                  />
                </BaseLayer>
              </LayersControl>
            ) : (
              <WMSTileLayer
                tiled="true"
                format="image/png"
                srs="EPSG:4326"
                layers={MapLayer}
                minZoom="7"
                maxZoom="16"
                url={mapurl}
                minResolution="auto"
                maxResolution="auto"
                projection="EPSG:4326"
              // resolution ={[0.0054931640625, 0.00274658203125, 0.001373291015625, 6.866455078125E-4, 3.4332275390625E-4, 1.71661376953125E-4, 8.58306884765625E-5, 4.291534423828125E-5, 2.1457672119140625E-5, 1.0728836059570312E-5]}
              />
            )}

            {cluster === false ? (
              states.filter === false &&
                storedata !== "" &&
                storedata !== undefined &&
                storedata !== null ? (
                storedata.map((item, index) => {
                  let positionsed =
                    item.latitude !== "" &&
                      item.latitude !== undefined &&
                      item.longitude !== undefined &&
                      item.longitude !== ""
                      ? [item.latitude, item.longitude]
                      : position;
                  return (
                    <>
                      <CustomRotatedMarker position={positionsed} selectedAsset={selectedAsset} item={item} index={index} fullscreenmode={fullscreenmode} />
                    </>
                  );
                })
              ) : states.filter === true &&
                panelfiltered_storedata !== "" &&
                panelfiltered_storedata !== undefined &&
                panelfiltered_storedata !== null ? (
                panelfiltered_storedata.map((item, index) => {
                  let positionsed =
                    item.latitude !== "" &&
                      item.latitude !== undefined &&
                      item.longitude !== undefined &&
                      item.longitude !== ""
                      ? [item.latitude, item.longitude]
                      : position;
                  return (
                    <>
                      <CustomRotatedMarker position={positionsed} selectedAsset={selectedAsset} item={item} index={index} fullscreenmode={fullscreenmode} />
                    </>
                  );
                })
              ) : ("")
            ) : (

              <MarkerClusterGroup
                onMouseOver={(e) => closeSingleselection()}              >
                {states.filter === false &&
                  storedata ? storedata.map((item, index) => {
                    let positionsed =
                      item?.latitude && item?.longitude
                        ? [item.latitude, item.longitude]
                        : position ? position : fallbackPosition;
                    return (
                      <>
                        <CustomRotatedMarker position={positionsed} selectedAsset={selectedAsset} item={item} index={index} fullscreenmode={fullscreenmode} />
                      </>
                    );
                  })
                  : states.filter === true &&
                    panelfiltered_storedata
                    ? panelfiltered_storedata.map((item, index) => {
                      let positionsed =
                        item?.latitude &&
                          item?.longitude
                          ? [item.latitude, item.longitude]
                          : position ? position : fallbackPosition;
                      return (
                        <>
                          <CustomRotatedMarker position={positionsed} selectedAsset={selectedAsset} item={item} index={index} fullscreenmode={fullscreenmode} />
                        </>
                      );
                    })
                    : ""}
              </MarkerClusterGroup>
            )}
            {/* Using to show the details of the single asset - one red Arrow Will appear on the top of Vehicle*/}
            {FocusAsset === true &&
              singleassetdata !== "" &&
              singleassetdata !== undefined &&
              focusicon !== "" &&
              focusicon !== undefined &&
              focusicon !== null &&
              focusicon.length > 0 ? (
              <>
                <FocusAssetMarker
                  position={[focusicon[0].latitude, focusicon[0].longitude]}
                  selectedAsset={selectedAsset}
                  item={focusicon[0]}
                  fullscreenmode={fullscreenmode}
                  zoom={states.zoom}
                />
              </>
            ) : ("")}

            {filterpoidetails && <POIFilter data={filterpoidetails} />
            }
            {states.focustrack === "true" && states.previoustrackdata && states.previoustrackdata.length > 1
              ? states.previoustrackdata.map((item, index) => {
                if (states.previoustrackdata[index + 1] !== undefined) {
                  let dataArr = [];

                  let speed =
                    item.speed <= 40
                      ? "#099345"
                      : item.speed >= 41 && item.speed <= 80
                        ? "#0000ff"
                        : item.speed >= 81 && item.speed <= 120
                          ? "#7d0000"
                          : item.speed >= 121
                            ? "#000000"
                            : "";

                  dataArr.push([
                    parseFloat(item.latitude),
                    parseFloat(item.longitude),
                  ]);
                  dataArr.push([
                    parseFloat(
                      states.previoustrackdata[index + 1].latitude
                    ),
                    parseFloat(
                      states.previoustrackdata[index + 1].longitude
                    ),
                  ]);
                  return (
                    <>
                      <Polyline
                        key={index}
                        positions={dataArr}
                        // color={speed}
                        arrowheads={{ size: "15px", frequency: "500m" }}
                      />
                    </>
                  );
                }
              }) : ""}

            {states.focustrack === "true" && states.statetrackdata &&
              states.statetrackdata.length > 1
              ? states.statetrackdata.map((item, index) => {
                if (states.statetrackdata[index + 1] !== undefined) {
                  let dataArr = [];
                  dataArr.push([
                    parseFloat(item.latitude),
                    parseFloat(item.longitude),
                  ]);
                  dataArr.push([
                    parseFloat(states.statetrackdata[index + 1].latitude),
                    parseFloat(
                      states.statetrackdata[index + 1].longitude
                    ),
                  ]);
                  return (
                    <>
                      {/* <Marker position={position} /> */}
                      <Polyline
                        key={index}
                        positions={dataArr}
                        // color={speed}
                        arrowheads={{ size: "15px", frequency: "500m" }}
                      />
                    </>
                  );
                }
              })
              : ""}
            {/* Current Track */}

            {/* Engine Start Point */}

            {states.focustrack === "true" && states.previoustrackdata && states.previoustrackdata.length >= 2 ? (
              <Marker position={[
                states.previoustrackdata[0].latitude,
                states.previoustrackdata[0].longitude,
              ]}
                onMouseOver={(e) => {
                  e.target.openPopup();
                }}
                onMouseOut={(e) => {
                  e.target.closePopup();
                }}
              >
                <Popup>Engine Start Point</Popup>
              </Marker>
            ) : ("")}

            {alertdata ? (<Marker
              position={[alertdata.latitude, alertdata.longitude]}
              // position={["25.313644", "55.374236"]}
              icon={alertdata.alertName === "Over Speed" ? OverspeedIcon : IdleIcon}
              onMouseOver={(e) => {
                e.target.openPopup();
              }}
              onMouseOut={(e) => {
                e.target.closePopup();
              }} >
            </Marker>) : ("")}

            {/* Alert View Icon */}

            <FullscreenControl
              position="topright"
              title="Full Screen"
              id="fullscreen-div" />

            {fullscreenmode === 1 &&
              ((speed_violation_count && speed_violation_count.length > 0) ||
                (idle_violation_count && idle_violation_count.length > 0)) ? (
              <ReactAudioPlayer
                src={notificationsound}
                autoPlay={
                  (speed_violation_count && speed_violation_count.length > 0) ||
                    (idle_violation_count && idle_violation_count.length > 0)
                    ? true : false
                }
                // autoPlay
                controls={false}
                loop={
                  (speed_violation_count && speed_violation_count.length > 0) ||
                    (idle_violation_count && idle_violation_count.length > 0)
                    ? true
                    : false
                }
              />
            ) : ("")}

            {fullscreenmode === 1 ? (
              <>
                <div className="liveviewicons_row_div fullscreen_status_icons">
                  <div>
                    <img
                      alt="Informap Logo"
                      src={ITCImg}
                      className="logoimg mr_10"
                    />
                  </div>
                  <TopBarFilter
                    livepanelfilter={livepanelfilter}
                    livepanelclick={livepanelclick}
                    filterCount={filterCount}
                    locationfilter={states.locationfilter}
                    fullscreen={fullscreenmode}
                    vehicletypeBike={vehicletypeBike}
                    vehicletypeOthers={vehicletypeOthers} />
                  <div className="fullscreen_time">
                    {moment(currentdate).format("llll")}
                  </div>
                </div>
              </>
            ) : ("")}

            {geofencecircleenable === true && geofencestatelatlng.geofencelat !== "" && geofencestatelatlng.geofencelng !== "" ? (
              <>
                <Circle
                  center={
                    [geofencestatelatlng.geofencelat, geofencestatelatlng.geofencelng]
                  }
                  radius={
                    geofencestatelatlng.radius !== "" && geofencestatelatlng.radius !== undefined
                      ? geofencestatelatlng.radius
                      : 400
                  }
                />
                <Marker
                  position={
                    [geofencestatelatlng.geofencelat, geofencestatelatlng.geofencelng]
                  }
                ></Marker>
              </>
            ) : ("")}

          </MapContainer>

        </div>
        <div className="control-section">
          <div id="wrapper">
            <CustomSideBarComponent
              filteredData={states.filter === false ? filteredData : panelfiltered_storedata}
              sidebarselectedAsset={sidebarselectedAsset}
              singleassetdata={singleassetdata}
              sensorview={sensorview}
            />
          </div>
        </div>

        <div className="control-section">
          <div id="wrapper">
            <SidebarComponent
              id="default-sidebar1"
              ref={(Sidebar) => (sidebarObj1 = Sidebar)}
              style={{ visibility: "visible" }}
              close={closesidebar}
              open={opensidebar}
              created={onCreateGeofence}
              type="Push"
              position="Left"
            >
              <AddGeofencebody geofencestatelatlng={geofencestatelatlng}
                vehiclelist={vehiclelist}
                actions={actions}
                levels={levels}
                handleReInitializeGeofence={handleReInitializeGeofence}
                geofenceRadius={geofenceRadius}
                handleLoaderView={handleLoaderView} />
            </SidebarComponent>
            <div>
              <div className="center-align">
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="quick-panel-tooltip">
                      Add Geofence
                    </Tooltip>
                  }
                >
                  <Button
                    onClick={righttoggleClick}
                    className={`${Geofencetoggleicon === 1 ? "right_300" : "right_0"
                      } ms_toggle_icon1`}
                  >
                    {Geofencetoggleicon === 1 ? (
                      //<ChevronRightIcon />
                      <img alt="Toggle icon" src={toAbsoluteUrl("/media/icons/Add-geofence.png")} />
                    ) : (<ChevronLeftIcon />
                    )}
                  </Button>
                </OverlayTrigger>
              </div>
            </div>
          </div>
        </div>

        <span className="ListViewIcon">
          <MuiTooltip title="Grid View" placement="top">
            <ListIcon
              size="small"
              onClick={listViewDrawer(true)}
              className="ListViewIcon_svg"
            >
              <ListIcon />
            </ListIcon>
          </MuiTooltip>
        </span>
        {listviewdrawer === true ? (
          <>
            <div className="List_View">
              <div className="List_view_head">
                <>
                  <span>
                    <h4>Grid View</h4>
                  </span>
                  <span className="listview_cancel_btn">
                    <CancelIcon
                      className="listview_cancel_btn_svg"
                      onClick={listViewDrawer(false)}
                    />
                  </span>
                </>
              </div>
              {states.filter === false &&
                filteredData !== "" &&
                filteredData !== undefined &&
                filteredData.length !== 0 ?
                <ListViewGridTable records={filteredData} sidebarselectedAsset={sidebarselectedAsset} singleassetdata={singleassetdata} />
                : states.filter === true &&
                  panelfiltered_storedata !== "" &&
                  panelfiltered_storedata !== undefined &&
                  panelfiltered_storedata !== null ?
                  <ListViewGridTable records={panelfiltered_storedata} sidebarselectedAsset={sidebarselectedAsset} singleassetdata={singleassetdata} />
                  : ""}

            </div>
          </>
        ) : ("")}

        {/* List View Section */}
      </div>
      {/* start - Single Asset Info Section  */}
      {singleassetdata !== "" ? (
        <>
          <div
            className={`${singleassetview === "hide" ? "hide" : "show"
              } single_asset_details pull-right`}
          >
            <SingleAssetInfo
              singleassetdata={singleassetdata}
              closesingleasset={closesingleasset}
              deviceuniqhueid={states.deviceuniqhueid}
              handleFocusTrackClick={handleFocusTrackClick}
              InputEventStatus={InputEventStatus} />
          </div>  </>) : ""
      }
      {/* <Modal
        open={AddPOI}
        onClose={handleClose}
        aria-labelledby="nearby_vehicle-title"
        aria-describedby="nearby_vehicle"
      >
        <AddrightclickPOI
          poilat={poistate.poilat}
          poilng={poistate.poilng}
          handleClose={handleClose}
        />
      </Modal> */}
      <Modal
        open={AddPOI}
        onClose={handleClose}
        aria-labelledby="nearby_vehicle-title"
        aria-describedby="nearby_vehicle"
        disableScrollLock
        disablePortal
        disableEnforceFocus
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,            // Adjust width
            bgcolor: "background.paper",  // White background
            boxShadow: 24,
            borderRadius: 2,
            p: 3,

          }}
        >
          <AddrightclickPOI
            poilat={poistate.poilat}
            poilng={poistate.poilng}
            handleClose={handleClose}
            onSuccess={(msg) => setSnackbar({ open: true, message: msg, severity: 'success' })}
            onError={(msg) => setSnackbar({ open: true, message: msg, severity: 'error' })}
          />
        </Box>
      </Modal>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </MuiAlert>
      </Snackbar>

    </>
  );
};
const mapStateToProps = ({ liveView, maplayer }) => ({
  liveView,
  maplayer,
});
export default connect(mapStateToProps, { liveViewAction })(LiveViewMap);